$(document).ready(function () {
    // Change url on selection of year group
    $('select[name="yeargroup"]').change(function () {
        window.location = base_url + 'regents?yeargroup=' + $(this).val();
    });

    var regentForm = $('#RegentForm');

    $(regentForm).validate({
        rules: {
            student_id: {
                required: true,
            },
            regent_id: {
                required: true,
            },
        },
        messages: {
            student_id: {
                required: 'Please select a student',
            },
            regent_id: {
                required: 'Please select a regent for this student',
            },
        },
        submitHandler: function (form) {
            form.submit();
        },
    });

    var studentSelect     = $('select#student_id');
    var regentSelect      = $('select#regent_id');
    var coordinatorSelect = $('select#coordinator_id');

    // Reset form if new regent/regentee
    $('.addregent').on('click', function () {
        $('input[type="hidden"][name="id"]').val('').change();
        $(studentSelect).val('').change();
        $(regentSelect).val('').change();
        $(coordinatorSelect).val('').change();
    });

    // Change values of form fields when editing an existing regent/regentee
    $('.editregent').on('click', function () {
        var id        = $(this).data('id');
        var studentid = $(this).data('studentid');
        var regentid  = $(this).data('regentid');
        var secid     = $(this).data('secid');

        $('input[type="hidden"][name="id"]').val(id).change();
        $(studentSelect).val(studentid).change();
        $(regentSelect).val(regentid).change();
        $(coordinatorSelect).val(secid).change();
    });

    $('.deleteregent').on('click', function () {
        var id          = $(this).data('id');
        var studentname = $(this).data('studentname');
        $('input[type="hidden"][name="id"]').val(id).change();
        $('input[type="hidden"][name="studentname"]').val(studentname).change();
        $('#deleteregent span.regentee-student').text(studentname);
    });
});
